(() => {
  const GLOBAL_KEY = 'RACollectionWishlist';
  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].sync();
    return;
  }

  const HOST_SELECTOR = 'body';
  const PLACEHOLDER_SELECTOR = '.tt-wishlist-plp-btn-main[data-pid][data-handle]';
  const ADDED_PRODUCT_SELECTOR = '.m-product-card, .tt-wishlist-plp-btn-main[data-pid][data-handle]';
  let host = null;
  let observer = null;
  let timer = null;
  let needsRefresh = false;
  let readyAttempts = 0;

  const schedule = (force = false) => {
    needsRefresh = needsRefresh || force;
    window.clearTimeout(timer);
    timer = window.setTimeout(refresh, 80);
  };

  const refresh = () => {
    timer = null;
    if (!host?.isConnected) return;
    const placeholders = Array.from(host.querySelectorAll(PLACEHOLDER_SELECTOR));
    if (!placeholders.length) return;
    const missingButtons = placeholders.some((node) => !node.querySelector('.wishlist-plp-btn-wrap'));
    if (!needsRefresh && !missingButtons) return;

    if (typeof window.wishlistButtonsInit !== 'function') {
      // The app is deferred too. Retry briefly, and check again on window load.
      if (readyAttempts++ < 30) timer = window.setTimeout(refresh, 200);
      return;
    }

    readyAttempts = 0;
    needsRefresh = false;
    // Use the app's own renderer and saved-state synchronization.
    // Its collection click handler is already delegated, so no extra handlers.
    window.wishlistButtonsInit();
  };

  const connect = () => {
    const nextHost = document.querySelector(HOST_SELECTOR);
    if (host !== nextHost) {
      observer?.disconnect();
      host = nextHost;
      if (host) {
        observer = new MutationObserver((mutations) => {
          const productsAdded = mutations.some((mutation) =>
            Array.from(mutation.addedNodes).some((node) =>
              node.nodeType === 1 &&
              (node.matches(ADDED_PRODUCT_SELECTOR) || node.querySelector(ADDED_PRODUCT_SELECTOR))
            )
          );
          if (productsAdded) schedule(true);
        });
        observer.observe(host, { childList: true, subtree: true });
      }
    }
    readyAttempts = 0;
    schedule();
  };

  window[GLOBAL_KEY] = { sync: connect };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connect, { once: true });
  } else {
    connect();
  }
  window.addEventListener('load', connect);
  window.addEventListener('pageshow', connect);
  document.addEventListener('shopify:section:load', connect);
})();

